import React from 'react';
import SEOHead from '../components/SEOHead';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import FUETechniqueSection from '../components/FUETechniqueSection';
import BeforeAfterGallery from '../components/BeforeAfterGallery';
import TrustProofSection from '../components/TrustProofSection';
import GoogleReviewsSection from '../components/GoogleReviewsSection';
import DoctorsSection from '../components/DoctorsSection';
import TrustSection from '../components/TrustSection';
import ProcessSection from '../components/ProcessSection';
import ContactSection from '../components/ContactSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <SEOHead page="landing" />
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <FUETechniqueSection />
        <BeforeAfterGallery />
        <TrustProofSection />
        <GoogleReviewsSection />
        <DoctorsSection />
        <TrustSection />
        <ProcessSection />
        <ContactSection />
        <CTASection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default LandingPage;
